import React, { useState, useEffect } from 'react';
import FormatString from '../../utilities/FormatString'
import formatAmount from '../../utilities/formatAmount'
import { useCookies } from 'react-cookie';
import styles from './TransactionItem.module.scss'
import { useParams } from 'react-router-dom';
import Checkbox from  '../FormElements/Inputs/Checkbox'
import Image from '../FormElements/Image/Image'
import Collapse from '../Collapse/Collapse'
import Svg from '../Svg/Svg'
import Separater from '../FormElements/Separater/Separater'
import {userImageUrls,
  CONVERTIBLE_CURRENCIES,
  radius,
} from '../../constants'

import {
  useHistory
} from '../../hooks'

const TransactionItem = (props) => {
  const [ collapseOpen , setCollapseOpen ] = useState(false)
  const { navigateTo, navigate } = useHistory();
  /* eslint-disable no-unused-vars */
  const [_, setCookie] = useCookies([]);
  const { group_id, accounting_book_id } = useParams();
  const open = collapseOpen && !props.editMode
  const [ isChecked, setIsChecked ] = useState(props.checked)

  useEffect(() => {
    if (props.selectedPaymentIds) {
      setIsChecked(props.selectedPaymentIds.includes(object.id.toString()))
      /* eslint-disable react-hooks/exhaustive-deps */
    }
  }, [props.selectedPaymentIds])

  let object = props.object
  let activeClass = open ? styles.active : ''
  let amount = object.amount

  const handleLabelOnCheck = (e) => {
    if (e.target.checked) {
      setCollapseOpen(true)
    } else {
      setCollapseOpen(false)
    }
  }

  const originRef = (originAmount) => {
    if (!object.origin_currency || originAmount === null || originAmount === undefined) { return null }
    return (
      <span className={[styles.alloOrigin].join(' ')}>
        ≈ {object.origin_currency_symbol || ''}{Number(originAmount).toLocaleString()}
      </span>
    )
  }

  let i = 0
  const allocations = object.allocations.map(allo => {
    i += 1
    return(
      <div key={i} className={[styles.allocation].join(' ')}>
        <div className={styles.allocationInner}>
          <span className={[styles.alloName].join(' ')}> { allo.ower_display_name } </span> <span className={[styles.alloAmount].join(' ')}>{formatAmount(allo.amount, props.exponent, props.currency_symbol)}{originRef(allo.origin_amount)}</span>
        </div>
      </div>
    )
  })

  const buildPaymentPayers = () => {
    let payment_payers = []

    if (object.payment_payers) {
      let i = 0
      payment_payers = object.payment_payers.map(pp => {
        i += 1
        return(
          <div key={`p-${i}`} className={[styles.allocation].join(' ')}>
            <div className={[styles.allocationInner, styles.green700, styles.thick].join(' ')}>
              <span className={[styles.alloName].join(' ')}> { pp.user_display_name } </span> <span className={[styles.alloAmount].join(' ')}>{formatAmount(pp.amount, props.exponent, props.currency_symbol)}{originRef(pp.origin_amount)}</span>
            </div>
          </div>
        )
      })
    }
    return payment_payers
  }

  const buildPaymentPayer = (display_name, amount) => {
    return (
      <div key={`p-${i}`} className={[styles.allocation].join(' ')}>
        <div className={[styles.allocationInner, styles.green700, styles.thick].join(' ')}>
          <span className={[styles.alloName].join(' ')}> { display_name } </span> <span className={[styles.alloAmount].join(' ')}>{formatAmount(amount, props.exponent, props.currency_symbol)}{originRef(object.origin_amount)}</span>
        </div>
      </div>
    )
  }

  let payment_payers = buildPaymentPayers()

  const handleDeleteClick = () => {
    props.deleted(object)
  }

  const handleEditClick = () => {
    navigate(`/liff_entry/groups/${group_id}/accounting_books/${accounting_book_id}/payments/${object.id}/edit`)
  }

  const handlePaidBackEditClick = () => {
    let payment = {
      id: object.id,
      description: object.description,
      amount: object.amount,
      paid_back: true,
      allocation_type: 'amount',
      payer_id:  object.payer_id,
      ower_id: object.allocations[0].ower_id
    }

    setCookie('payment', payment, { path: '/' });
    navigateTo('paidBackPaymentPage', { group_id, accounting_book_id, payment })
  }

  const handleCheckboxChaned = (e) => {
    setIsChecked(e.target.checked)
    props.changed(e.target.checked, e.target.value)
  }

  let paidBack = ""
  if (object.paid_back) { paidBack = styles.paidBack }

  let selected = object.payment_payers
  let displayUsers = 0
  let displayCount = 1
  let multiPayerCount = 1
  let images = []
  if (selected) {
    multiPayerCount = selected.length
    displayCount = selected.length > 3 ? 3 : selected.length
    displayUsers = [...selected].slice(0, displayCount)
    let idx = 0
    images = displayUsers.map(u => {
      let imageUrl = u.user_image_url
      if (!imageUrl) {
        imageUrl = userImageUrls[u.imageId]
      }

      idx++
      return(
        <Image style={{
          position: 'relative',
          left: idx === 1 ? '0px' : `${-5 * (idx - 1)}px`,
          borderRadius: radius.circle,
          zIndex: 30 - idx
        }}
          key={idx}
          size='20px'
          imageUrl={imageUrl} />
      )
    })
  }


  let extraPadding = 6
  if (displayCount === 2) {
    extraPadding = 6
  } else if (displayCount === 3){
    extraPadding = 20
  }

  let payerCount = 1
  if (object.payment_payers) {
    payerCount = object.payment_payers.length
  }

  let userOwnedAllocation = object.allocations.filter(a => a.owned_by_current)[0]

  return (
    <>
      <div
        className={[styles.container, activeClass, paidBack, props.onSelect ? styles.selectable : '', (props.onSelect && props.selected) ? styles.selected : ''].join(' ')}
        onClick={props.onSelect ? () => props.onSelect(object) : undefined}
      >
        <label className={[`${activeClass} ${paidBack}`, styles.label].join(" ")}>
          {
            props.onSelect ? null :
            props.editMode ?
              <Checkbox style={{"paddingRight": "5px"}} checked={isChecked} value={object.id.toString()} changed={handleCheckboxChaned}/>:
              <div className={[styles.checkbox].join(" ")}>
                <input
                  onChange={handleLabelOnCheck}
                  type="checkbox"
                  value={ object.id }
                />
              </div>
          }
          <div className={[styles.paymentBlock].join(' ')}>
            <div className={[styles.name].join(" ")}>
              <div className={[styles.description].join(" ")}>
                {
                  object.paid_back ?
                    FormatString.sliceToLength(`還 ${object.allocations[0].ower_display_name}`, 18, '..')
                    :
                    FormatString.sliceToLength(object.description, 18, '..')
                }
              </div>
              <div className={[styles.message].join(" ")} style={{ textAlign: 'right' }}>
                <div>{formatAmount(amount, props.exponent, props.currency_symbol)}</div>
                {
                  object.origin_currency ?
                    <div style={{ fontSize: '0.72em', fontWeight: 400, opacity: 0.55, marginTop: '1px' }}>
                      {(CONVERTIBLE_CURRENCIES.find((c) => c.code === object.origin_currency) || {}).flag || ''}
                      {' '}
                      {object.origin_currency_symbol || ''}{Number(object.origin_amount).toLocaleString()} {object.origin_currency}
                    </div> : null
                }
              </div>
            </div>
            <div className={[styles.amount].join(" ")}>
              <div className={[styles.amountLeft].join(" ")}>
                {
                  object.multi_payer ?
                    <>
                      <div className={styles.multiImage}>
                        {images}
                        <div
                          className={styles.countBox}
                          style={{
                            position: 'relative',
                            right: `${(displayCount - 1) * 40}px`,
                            right: `16px`,
                            bottom: '-5px',
                            display: "none"
                          }}>
                          <div style={{display: "none"}}className={styles.countSection}>
                            {
                              selected.length > 1 ?
                                <div className={[styles.count].join(' ')}>
                                  {selected.length}
                                </div> : null
                            }
                          </div>
                        </div>
                      </div>
                    </>
                    :
                    <>
                      <div className={[styles.image].join(' ')}>
                        <Image imageUrl={object.payer_image_url} defaultImage='user' size='20px'/>
                      </div>
                    </>
                }
                <div className={[styles.description].join(" ")} style={{paddingLeft: `${extraPadding}px`}}>
                  {
                    object.paid_back ?
                      <p className={[styles.paidBack, styles.payerLine].join(" ")}>
                        <span className={styles.payerName}>{object.payer_display_name}</span>
                        <span className={styles.payerSuffix}>還款</span>
                      </p>
                      :
                      <p className={styles.payerLine}>
                        {
                          multiPayerCount == 1 ?
                            <>
                              <span className={styles.payerName}>{object.payer_display_name}</span>
                              <span className={styles.payerSuffix}>付款</span>
                            </>
                            : `${multiPayerCount}人付款`
                        }
                      </p>
                  }
                </div>
              </div>
              {
                !object.paid_back ?
                  <div className={[styles.message].join(" ")}>
                    {object.allocations.length}人分
                    {
                      userOwnedAllocation ?
                        ` | 我負擔 ${formatAmount(userOwnedAllocation.amount, props.exponent, props.currency_symbol)}` : ""
                    }
                  </div>: null
              }
            </div>
          </div>
        </label>
      </div>
      { !props.onSelect &&
      <Collapse isOpened={open}
        initialStyle={open ? { height: 'auto', overflow: 'initial' } : { height: '0px', overflow: 'hidden' }} >
        <div className={[`${paidBack}`, styles.paymentCollapse].join(" ")}>
          {
            object.paid_back ?
              null
              :
                <div className={[styles.allocations].join(" ")}>
                  {
                    object.multi_payer ?
                      <>
                        <div className={[styles.allocationSection].join(' ')}  style={{ paddingTop: "4px" }}>
                          <div className={[styles.allocation].join(' ')}>付款</div>
                        </div>
                        {payment_payers}
                        <Separater style={{ margin: "4px" }}/>
                      </>
                      :
                      <>
                        <div className={[styles.allocationSection].join(' ')}  style={{ paddingTop: "4px" }}>
                          <div className={[styles.allocation].join(' ')}>付款</div>
                        </div>
                        {buildPaymentPayer(object.payer_display_name, object.amount)}
                        <Separater style={{ margin: "4px" }}/>
                      </>
                  }
                  <div className={[styles.allocationSection].join(' ')}>
                    <div className={[styles.allocation].join(' ')}>分款</div>
                  </div>
                  {allocations}
                </div>
          }
          {
            props.lock_status == "locked" && !object.paid_back ?
              null :
              <div className={[styles.buttons, paidBack].join(" ")}>
                <div onClick={handleDeleteClick} className={[styles.btn].join(" ")}>
                  刪除
                </div>
                {
                  object.paid_back ? null :
                    <div onClick={handleEditClick} className={[styles.btn, styles.edit].join(' ')}>
                      編輯
                    </div>
                }
              </div>
          }
        </div>
      </Collapse> }
    </>
  )
};

export default TransactionItem;
